import { useEffect, useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { authApi } from "../features/auth/authApi.js";
import { Link, ROUTES } from "./router/index.js";

const disabledOverview = ["dashboard", "rounds", "players"] as const;

export function AdminLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const [role, setRole] = useState("—");
  const [canReadAudit, setCanReadAudit] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try {
        const access = await authApi.access();
        if (!active) return;
        setRole(access.role);
        setCanReadAudit(access.permissions.includes("audit.read"));
      } catch {
        if (!active) return;
        setRole("—");
        setCanReadAudit(false);
      }
    };
    void refresh();
    const onFocus = () => void refresh();
    window.addEventListener("focus", onFocus);
    return () => {
      active = false;
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  return (
    <div className="cx-admin-layout">
      <aside className="cx-admin-sidebar" aria-label={t("adminNav.label")}>
        <nav className="cx-admin-nav">
          <section>
            <h2>{t("adminNav.overview")}</h2>
            {disabledOverview.map((item) => (
              <span key={item} aria-disabled="true">
                {t(`adminNav.${item}`)}
              </span>
            ))}
          </section>
          <section>
            <h2>{t("adminNav.appearance")}</h2>
            <Link to={ROUTES.adminThemes}>{t("adminNav.themes")}</Link>
            <Link to={ROUTES.adminVehicles}>{t("adminNav.vehicles")}</Link>
          </section>
          <section>
            <h2>{t("adminNav.operations")}</h2>
            <Link to={ROUTES.adminSettings}>{t("adminNav.settings")}</Link>
            <span aria-disabled="true">{t("adminNav.moderation")}</span>
            {canReadAudit ? <Link to={ROUTES.adminAudit}>{t("adminNav.audit")}</Link> : null}
          </section>
        </nav>
        <div className="cx-admin-account">
          <strong>{t("adminNav.account")}</strong>
          <span>{t(`chat.roles.${role}`, { defaultValue: role })}</span>
        </div>
      </aside>
      <div className="cx-admin-content">{children}</div>
    </div>
  );
}
